import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "w-240 min-h-192" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pt-4 pl-4 font-light font-roboto text-blue-800 text-2xl" }, " Ülesvõtete lisamine töötajale ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectWorker = _resolveComponent("SelectWorker")!
  const _component_FillImages = _resolveComponent("FillImages")!
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-wrapper" }, [
    _createVNode(_component_ModalWrapper, {
      open: _ctx.isOpen,
      onOnclose: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          (_ctx.step === _ctx.AddReportsToWorkerStep.SELECT_WORKER)
            ? (_openBlock(), _createBlock(_component_SelectWorker, {
                key: 0,
                onOnWorker: _ctx.onWorker
              }, null, 8, ["onOnWorker"]))
            : (_ctx.step === _ctx.AddReportsToWorkerStep.FILL_IMAGES)
              ? (_openBlock(), _createBlock(_component_FillImages, {
                  key: 1,
                  worker: _ctx.selectedWorker,
                  onOnAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false))
                }, null, 8, ["worker"]))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["open", "onOnclose"])
  ]))
}